"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startDocumentsListeners = startDocumentsListeners;
const document_1 = require("../../slices/document");
const _1 = require(".");
function startDocumentsListeners() {
    (0, _1.startListening)({
        predicate(_action, currentState, originalState) {
            return currentState.getUserOptions.appUser?.id !== originalState.getUserOptions.appUser?.id;
        },
        effect(_action, listenerAPI) {
            listenerAPI.dispatch((0, document_1.resetDocuments)());
        },
    });
    (0, _1.startListening)({
        predicate(_action, currentState, originalState) {
            return (currentState.documents.documentJson?.character_id !== originalState.documents.documentJson?.character_id);
        },
        effect(_action, { dispatch, getState }) {
            const files = getState().documents.documentJson?.files;
            if (files) {
                dispatch((0, document_1.setSelectedFileIds)(files.filter((file) => file.selected === 'Y').map((file) => file.id)));
            }
        },
    });
}
